import * as actionTypes from './types';
import { adminAnalyticsApi } from '../../services/adminAnalyticsApi.ts';
import {
  AdminAnalyticsFilters,
  AnalyticsOverviewResponse,
} from '../../types/adminAnalytics.ts';
import { getDefaultAnalyticsPeriod } from '../../utils/adminAnalyticsHelpers.ts';

const defaultPeriod = getDefaultAnalyticsPeriod();

export const getInitialAdminAnalyticsFilters = (): AdminAnalyticsFilters => ({
  from: defaultPeriod.from,
  to: defaultPeriod.to,
  compareFrom: null,
  compareTo: null,
  useExplicitCompare: false,
  includeDeleted: false,
  usersValidatedOnly: false,
  activeSection: 'all',
});

export const setAdminAnalyticsFilters = (filters: Partial<AdminAnalyticsFilters>) => ({
  type: actionTypes.SET_ADMIN_ANALYTICS_FILTERS,
  payload: filters,
});

export const fetchAdminAnalyticsOverview = () => {
  return async (dispatch: any, getState: any) => {
    const filters: AdminAnalyticsFilters =
      getState().backoffice.analyticsFilters ?? getInitialAdminAnalyticsFilters();

    dispatch({ type: actionTypes.FETCH_ADMIN_ANALYTICS_LOADING });

    try {
      const data = await adminAnalyticsApi.fetchOverview(filters);
      dispatch({
        type: actionTypes.FETCH_ADMIN_ANALYTICS_SUCCESS,
        payload: data,
      });
    } catch (error: any) {
      const message =
        error?.response?.status === 403
          ? 'No tenés permisos de administrador para ver estadísticas.'
          : error?.response?.data?.message ||
            error?.message ||
            'Error al cargar estadísticas.';
      dispatch({
        type: actionTypes.FETCH_ADMIN_ANALYTICS_ERROR,
        payload: message,
      });
    }
  };
};

export type { AnalyticsOverviewResponse, AdminAnalyticsFilters };
